import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { apiError } from "@/lib/api";
import { Input } from "@/components/ui/input";
import { Button } from "@/components/ui/button";
import { Label } from "@/components/ui/label";
import { BowlFood } from "@phosphor-icons/react";

export default function Login() {
  const { login, user } = useAuth();
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (user) navigate("/", { replace: true });
  }, [user, navigate]);

  const onSubmit = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);
    try {
      await login(email, password);
      navigate("/");
    } catch (err) {
      setError(apiError(err));
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen grid lg:grid-cols-2 bg-[#FAF9F6]">
      <div className="hidden lg:block relative">
        <img
          src="https://images.unsplash.com/photo-1602881917445-0b1ba001addf?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2Nzh8MHwxfHNlYXJjaHwyfHxwb2tlJTIwYm93bHxlbnwwfHx8fDE3ODYzOTMxNzB8MA&ixlib=rb-4.1.0&q=85"
          alt="Poke Bowl RisoRice"
          className="absolute inset-0 h-full w-full object-cover"
        />
        <div className="absolute inset-0 bg-gradient-to-t from-black/60 via-transparent to-transparent" />
        <div className="absolute bottom-12 left-12 right-12 text-white">
          <p className="text-3xl font-bold leading-snug">Fresco. Componibile. Sotto controllo.</p>
          <p className="text-white/80 mt-3">Gestisci tutto il tuo ristorante da un unico pannello.</p>
        </div>
      </div>
      <div className="flex items-center justify-center p-8">
        <div className="w-full max-w-md fade-in">
          <div className="flex items-center gap-3 mb-12">
            <div className="h-12 w-12 rounded-2xl bg-[#D95D39] flex items-center justify-center">
              <BowlFood size={28} weight="fill" className="text-white" />
            </div>
            <h1 className="text-2xl font-extrabold text-[#1C1C1C]">RisoRice</h1>
          </div>
          <h2 className="text-3xl font-bold mb-2">Bentornato</h2>
          <p className="text-[#6B7280] mb-10">Accedi per gestire menu, bowl, ingredienti e magazzino.</p>
          <form onSubmit={onSubmit} className="space-y-6">
            <div className="space-y-2">
              <Label htmlFor="email">Email</Label>
              <Input
                id="email"
                type="email"
                data-testid="login-email-input"
                placeholder="admin@risorice.it"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                required
                className="h-12"
              />
            </div>
            <div className="space-y-2">
              <Label htmlFor="password">Password</Label>
              <Input
                id="password"
                type="password"
                data-testid="login-password-input"
                placeholder="••••••••"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                required
                className="h-12"
              />
            </div>
            {error && (
              <p data-testid="login-error" className="text-sm text-[#D32F2F] bg-red-50 border border-red-100 rounded-lg px-4 py-3">
                {error}
              </p>
            )}
            <Button
              type="submit"
              data-testid="login-submit-button"
              disabled={loading}
              className="w-full h-12 rounded-full bg-[#D95D39] hover:bg-[#BF4F2F] text-white font-semibold text-base"
            >
              {loading ? "Accesso in corso..." : "Accedi"}
            </Button>
            <a
              href="https://areapaq.it/login"
              data-testid="login-areapaq-link"
              className="block text-center text-sm text-[#6B7280] hover:text-[#D95D39] underline underline-offset-4"
            >
              Accedi tramite il portale AreaPAQ
            </a>
          </form>
        </div>
      </div>
    </div>
  );
}
